module.exports = __webpack_public_path__ + "static/home-header-animation-00692223c299ecb526da52575d855fe3.gif";